export const initializedSDKs = {};

export const registerInitializedSDK = sdkName => {
  initializedSDKs[sdkName] = true;
};

export const isSDKInitialized = sdkName => {
  return initializedSDKs[sdkName] || false;
};
